import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API = `${BACKEND_URL}/api`;
export const WS_BASE = `${BACKEND_URL.replace(/^http/, "ws")}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
http.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const isAuth = cfg?.url?.includes("/auth/");
    const isAdmin = cfg?.url?.startsWith("/admin");
    if (error.response?.status === 401 && cfg && !cfg._retry && !isAuth && isAdmin) {
      cfg._retry = true;
      refreshing = refreshing || http.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return http(cfg);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(e, fallback = "Ocorreu um erro. Tente novamente.") {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.response ? fallback : "Falha de conexão. Verifique sua internet.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail?.msg || String(detail);
}
